import {makeAutoObservable} from "mobx";

export default class ChannelStore {
    constructor() {
        this._channelId = null
        makeAutoObservable(this)
    }
    setChannelId(newChannelId) {
        this._channelId = newChannelId
    }
    get channelId() {
        return this._channelId
    }
}